export const CorePalePalette: any = {
    0: '#BDC3CC',
    1: '#FFB3D1',
    2: '#FFB3D1',
    3: '#FAAEED',
    4: '#C7B6FC',
    5: '#C7B6FC',
    6: '#C7ECFF',
    7: '#C7ECFF',
    8: '#C7ECFF',
    9: '#A7ECE4',
    10: '#B0EDC0',
    11: '#B0EDC0',
    12: '#B0EDC0',
    13: '#A7ECE4',
    14: '#FDE8A5',
    15: '#FFD8B8',
    16: '#FFC5C2',
    17: '#BDC3CC',
    18: '#BDC3CC',
    19: '#DFC2B3',
    20: '#BBCEFF',
    21: '#BBCEFF',
    22: '#C7B6FC',
    23: '#BDC3CC',
    24: '#C7B6FC',
    25: '#BDC3CC',
    26: '#FFB3D1',
    27: '#9FAEFE',
    28: '#9EEDF8',
    29: '#B9F6D6',
    30: '#97D4B0',
    31: '#D7F1A4',
    32: '#FBB1AF',
    33: '#FFB4E1',
    34: '#DD9EE7',
    35: '#C291E0',
    36: '#B5A0E2',
    37: '#D7ACAC',
    38: '#BAACAC',
}

export const CorePaleBorderPalette: any = {
    0: '#AEB6C1',
    1: '#FCA6C8',
    2: '#FCA6C8',
    3: '#F69DE7',
    4: '#B8A3FA',
    5: '#B8A3FA',
    6: '#BAE6FD',
    7: '#BAE6FD',
    8: '#BAE6FD',
    9: '#94E5DC',
    10: '#9FE9B2',
    11: '#9FE9B2',
    12: '#9FE9B2',
    13: '#94E5DC',
    14: '#FCDD7E',
    15: '#FDCFAA',
    16: '#FDB8B5',
    17: '#AEB6C1',
    18: '#AEB6C1',
    19: '#D9B7A6',
    20: '#AFC8FD',
    21: '#AFC8FD',
    22: '#B8A3FA',
    23: '#AEB6C1',
    24: '#B8A3FA',
    25: '#AEB6C1',
    26: '#FCA6C8',
    27: '#8E9FF4',
    28: '#85E0ED',
    29: '#A0EECA',
    30: '#8AC6A2',
    31: '#C6E08E',
    32: '#EFA09E',
    33: '#F19DCF',
    34: '#C788D1',
    35: '#B284CE',
    36: '#A793D1',
    37: '#C79A9A',
    38: '#A99999',
}
